import {ControllerBase} from "../../../controllerBase";

declare var window: any;

export const EditarFreteController = ControllerBase.extend({
    name: "EditarFreteController",

    framework: "knockout",

    ajax: function() {

        return {
            url: "/Orcamento/_EditarFrete",
            type: "post",
            cache: false
        };
    },

    aplicar: function() {

        var model = this.toJS(this.model);
        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirFreteCarga",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                frete: model
            }),
            success: function(data) {

                if (!data) {
                    return;
                }


                self.model.Ticket(data.Ticket);
                self.model.Valor(data.Valor);

                self.orcamento.atualizarTotaisOrcamento();

                window.orcamentoController.model.DadosAlteradosEntrega["frete"] = false;
                global.showSuccessMessage("Frete alterado com sucesso");

                if (self.finalizarCallback) {
                    self.finalizarCallback();
                }


            }
        });

    },

    aposBinding: function () {
        for (var item in this.model.__ko_mapping__.mappedProperties) {
            this.model[item].subscribe(function () {
                window.orcamentoController.model.DadosAlteradosEntrega["frete"] = true;
            });
        }
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },


});

window.EditarFreteController = EditarFreteController
